import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', component: () => import('@/views/HomeView.vue') },
  {
    path: '/category/:type/:path*', // 动态匹配多级路径
    component: () => import('@/views/CategoryView.vue'), // 静态导入
    props: true
  },
  {
    path: '/location-map', // 地图页面路由
    component: () => import('@/views/LocationCategoryView.vue')
  },
  { path: '/detail/:id', component: () => import('@/views/DetailView.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router